// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popUpNewsContainer_DYpbP {
    background: var(--white-background);
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    box-shadow: 0 0 20px -10px var(--black-005-shadow);
    border-radius: 10px;
    padding: 10px;
    z-index: 3;
    display: inline-flex;
    flex-direction: column;
    gap: 4px;
    padding: 0px;

    &::-webkit-scrollbar {
        display: none;
    }

    .popUpNewsContainerHeader_M71Ph {
        gap: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        position: relative;

  

    }

  
}



.popUpNewsContainerItems_a7odI {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    padding: 10px;

    .popUpNewsContainerItem_goTtO {
        cursor: pointer;
        border-radius: 10px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        background: var(--f4-background);
        padding: 8px;
        gap: 8px;

        .content_fy48q {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;

            .header_Bm1dI {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;

                img {
                    width: 20px;
                    height: 20px;
                }

                b {
                    font-size: 12px;
                    font-weight: 600;
                }
            }

            p {
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
            }

            span {
                font-size: 12px !important;
                font-weight: 500;
            }
        }

        .image_U1oVZ {
            position: relative;
            width: 80px;
            height: 80px;
            min-width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                position: absolute;
                top: 0;
                left: 0;
            }

            div {
                border: none;
                cursor: pointer;
                width: 30px;
                height: 30px;
                display: inline-flex;
                align-items: center;
                background: var(--white-background);
                box-shadow: 0px 0px 10px -4px #aaaaaa;
                justify-content: center;
                border-radius: 50%;

                svg {
                    width: 18px;
                    height: 22px;
                }
            }
        }
    }
}



@media (max-width: 968px) {
    .popUpNewsContainerItems_a7odI {
        grid-template-columns: 1fr 1fr;
    }
}



@media (max-width: 500px) {
    .popUpNewsContainerItems_a7odI {
        grid-template-columns: 1fr;
    }
}


.sourceEllipsis_eljo0 {
    margin-bottom: 0px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100px;
    flex: 1 1;
}

.titleEllipsis_aAJSS {
    font-size: 13px;
    font-weight: 600;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.3;
    margin-top: 2px;
    margin-bottom: 4px;
}

.newsImage_PhBu2 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 5px;
    z-index: 1;
    position: relative;
}

.iconOverlay_OGhWL {
    position: absolute;
    bottom: -8px;
    right: -8px;
    z-index: 2;
    background: #1e1e1e;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.iconOverlay_OGhWL svg {
    width: 12px;
    height: 12px;
    fill: rgb(218, 8, 8);
    color: var(--white-color);
}

.popUpNewsHeaderBanner_dsx5o {
    position: relative;
    width: 100%;
    height: 140px;
    background-size: cover;
    background-position: 0px -58px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding: 0 16px 12px;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
}

.headerText_k1KSM {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    color: var(--white-color);

    b {
        font-size: 24px;
        font-weight: 600;
    }

    span {
        margin-left: 2px;
        font-size: 12px;
        font-weight: 400;
    }
}

.magicIconOverlay_iQRAC {
    position: absolute;
    bottom: 8px;
    right: 14px;
    z-index: 3;
    background: var(--_16c098-color);
    border-radius: 50%;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
}

.magicIconOverlay_iQRAC svg {
    width: 22px;
    height: 24px;
    fill: var(--white-color);
    color: var(--white-color);
    opacity: 0.8;
    transition: transform 0.2s ease;
}

.magicIconOverlay_iQRAC:hover svg {
    transform: scale(1.1);
    opacity: 1;
}

.popUpNewsActionsBar_tr5Ae {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 0px 10px 6px;
    background: var(--white-background);
    border-bottom: 1px solid var(--e0-border);
}

.stockTicker_OkMPa {
    display: flex;
    overflow-x: auto;
    gap: 12px;
    padding: 8px 10px;
    border-radius: 10px;
}

.stockTicker_OkMPa {
    scroll-behavior: smooth;
}

.stockTicker_OkMPa::-webkit-scrollbar {
    height: 4px;
}

.stockTicker_OkMPa::-webkit-scrollbar-thumb {
    background-color: #b3e7dd;
    border-radius: 10px;
}


.stockItem_qot0P {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    min-width: 120px;
    font-size: 11px;
    line-height: 1.2;
}


.stockLeft_QBWut {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.stockType_PNia_ {
    font-size: 10px;
    color: #888;
    font-weight: 500;
    text-transform: uppercase;
}

.stockName_xvxlf {
    font-size: 11px;
    font-weight: 500;
    color: #222;
}

.stockRight_lppsz {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    text-align: right;
}

.stockPrice_xkFMb {
    font-weight: bold;
    font-size: 11px;
    color: var(--black-color);
}

.stockVariation_sNVPz {
    font-size: 10px;
    font-weight: 600;
    margin-top: 2px;
}



.positive_h2d90 {
    color: var(--_16c098-color);
}

.negative_jXYoy {
    color: #d74b4b;
}

.newsFilters_QhcIG {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.filterButton_yWheq {
    border: 1px solid var(--ececf1-border);
    background: var(--white-background);
    border-radius: 20px;
    padding: 4px 12px;
    font-size: 13px;
    cursor: pointer;
}

.coverageButton_kd1pX {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #16c09824;
    border: none;
    color: var(--_16c098-color);
    font-weight: 600;
    font-size: 13px;
    padding: 4px 12px;
    border-radius: 20px;
    cursor: pointer;
    svg{
        fill: var(--_16c098-color);
        color: var(--_16c098-color);
    }
}

.searchButton_c_EoU {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--f4-background);
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    margin-left: auto;
}

.searchButton_c_EoU svg {
    width: 16px;
    height: 16px;
}





.bannerOverlay_oImKv {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/News/News.module.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kDAAkD;IAClD,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,sBAAsB;IACtB,QAAQ;IACR,YAAY;;IAEZ;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,WAAW;QACX,kBAAkB;;;;IAItB;;;AAGJ;;;;AAIA;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,aAAa;;IAEb;QACI,eAAe;QACf,mBAAmB;QACnB,aAAa;QACb,uBAAuB;QACvB,2BAA2B;QAC3B,gCAAgC;QAChC,YAAY;QACZ,QAAQ;;QAER;YACI,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,uBAAuB;;YAEvB;gBACI,aAAa;gBACb,mBAAmB;gBACnB,uBAAuB;gBACvB,SAAS;;gBAET;oBACI,WAAW;oBACX,YAAY;gBAChB;;gBAEA;oBACI,eAAe;oBACf,gBAAgB;gBACpB;YACJ;;YAEA;gBACI,eAAe;gBACf,gBAAgB;gBAChB,iBAAiB;YACrB;;YAEA;gBACI,0BAA0B;gBAC1B,gBAAgB;YACpB;QACJ;;QAEA;YACI,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,eAAe;YACf,aAAa;YACb,mBAAmB;YACnB,uBAAuB;;YAEvB;gBACI,WAAW;gBACX,YAAY;gBACZ,iBAAiB;gBACjB,kBAAkB;gBAClB,MAAM;gBACN,OAAO;YACX;;YAEA;gBACI,YAAY;gBACZ,eAAe;gBACf,WAAW;gBACX,YAAY;gBACZ,oBAAoB;gBACpB,mBAAmB;gBACnB,mCAAmC;gBACnC,qCAAqC;gBACrC,uBAAuB;gBACvB,kBAAkB;;gBAElB;oBACI,WAAW;oBACX,YAAY;gBAChB;YACJ;QACJ;IACJ;AACJ;;;;AAIA;IACI;QACI,8BAA8B;IAClC;AACJ;;;;AAIA;IACI;QACI,0BAA0B;IAC9B;AACJ;;;AAGA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,4BAA4B;IAC5B,6BAA6B;IAC7B,4BAA4B;IAC5B,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,yBAAyB;;IAEzB;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,UAAU;IACV,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,qBAAqB;IACrB,mCAAmC;IACnC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;;;AAIA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,mCAAmC;IACnC,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;;;;AAMA;IACI,kBAAkB;IAClB,QAAQ;IACR,yEAAyE;IACzE,UAAU;AACd","sourcesContent":[".popUpNewsContainer {\n    background: var(--white-background);\n    width: 100%;\n    height: 100%;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    box-shadow: 0 0 20px -10px var(--black-005-shadow);\n    border-radius: 10px;\n    padding: 10px;\n    z-index: 3;\n    display: inline-flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 0px;\n\n    &::-webkit-scrollbar {\n        display: none;\n    }\n\n    .popUpNewsContainerHeader {\n        gap: 10px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        position: relative;\n\n  \n\n    }\n\n  \n}\n\n\n\n.popUpNewsContainerItems {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 10px;\n    padding: 10px;\n\n    .popUpNewsContainerItem {\n        cursor: pointer;\n        border-radius: 10px;\n        display: flex;\n        align-items: flex-start;\n        justify-content: flex-start;\n        background: var(--f4-background);\n        padding: 8px;\n        gap: 8px;\n\n        .content {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            justify-content: center;\n\n            .header {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap: 10px;\n\n                img {\n                    width: 20px;\n                    height: 20px;\n                }\n\n                b {\n                    font-size: 12px;\n                    font-weight: 600;\n                }\n            }\n\n            p {\n                font-size: 12px;\n                font-weight: 400;\n                line-height: 16px;\n            }\n\n            span {\n                font-size: 12px !important;\n                font-weight: 500;\n            }\n        }\n\n        .image {\n            position: relative;\n            width: 80px;\n            height: 80px;\n            min-width: 80px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n                position: absolute;\n                top: 0;\n                left: 0;\n            }\n\n            div {\n                border: none;\n                cursor: pointer;\n                width: 30px;\n                height: 30px;\n                display: inline-flex;\n                align-items: center;\n                background: var(--white-background);\n                box-shadow: 0px 0px 10px -4px #aaaaaa;\n                justify-content: center;\n                border-radius: 50%;\n\n                svg {\n                    width: 18px;\n                    height: 22px;\n                }\n            }\n        }\n    }\n}\n\n\n\n@media (max-width: 968px) {\n    .popUpNewsContainerItems {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n\n\n@media (max-width: 500px) {\n    .popUpNewsContainerItems {\n        grid-template-columns: 1fr;\n    }\n}\n\n\n.sourceEllipsis {\n    margin-bottom: 0px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100px;\n    flex: 1;\n}\n\n.titleEllipsis {\n    font-size: 13px;\n    font-weight: 600;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    line-height: 1.3;\n    margin-top: 2px;\n    margin-bottom: 4px;\n}\n\n.newsImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 5px;\n    z-index: 1;\n    position: relative;\n}\n\n.iconOverlay {\n    position: absolute;\n    bottom: -8px;\n    right: -8px;\n    z-index: 2;\n    background: #1e1e1e;\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.iconOverlay svg {\n    width: 12px;\n    height: 12px;\n    fill: rgb(218, 8, 8);\n    color: var(--white-color);\n}\n\n.popUpNewsHeaderBanner {\n    position: relative;\n    width: 100%;\n    height: 140px;\n    background-size: cover;\n    background-position: 0px -58px;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    padding: 0 16px 12px;\n    overflow: hidden;\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n}\n\n.headerText {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    color: var(--white-color);\n\n    b {\n        font-size: 24px;\n        font-weight: 600;\n    }\n\n    span {\n        margin-left: 2px;\n        font-size: 12px;\n        font-weight: 400;\n    }\n}\n\n.magicIconOverlay {\n    position: absolute;\n    bottom: 8px;\n    right: 14px;\n    z-index: 3;\n    background: var(--_16c098-color);\n    border-radius: 50%;\n    width: 26px;\n    height: 26px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);\n}\n\n.magicIconOverlay svg {\n    width: 22px;\n    height: 24px;\n    fill: var(--white-color);\n    color: var(--white-color);\n    opacity: 0.8;\n    transition: transform 0.2s ease;\n}\n\n.magicIconOverlay:hover svg {\n    transform: scale(1.1);\n    opacity: 1;\n}\n\n.popUpNewsActionsBar {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 0px 10px 6px;\n    background: var(--white-background);\n    border-bottom: 1px solid var(--e0-border);\n}\n\n.stockTicker {\n    display: flex;\n    overflow-x: auto;\n    gap: 12px;\n    padding: 8px 10px;\n    border-radius: 10px;\n}\n\n.stockTicker {\n    scroll-behavior: smooth;\n}\n\n.stockTicker::-webkit-scrollbar {\n    height: 4px;\n}\n\n.stockTicker::-webkit-scrollbar-thumb {\n    background-color: #b3e7dd;\n    border-radius: 10px;\n}\n\n\n.stockItem {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    min-width: 120px;\n    font-size: 11px;\n    line-height: 1.2;\n}\n\n\n.stockLeft {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n}\n\n.stockType {\n    font-size: 10px;\n    color: #888;\n    font-weight: 500;\n    text-transform: uppercase;\n}\n\n.stockName {\n    font-size: 11px;\n    font-weight: 500;\n    color: #222;\n}\n\n.stockRight {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: center;\n    text-align: right;\n}\n\n.stockPrice {\n    font-weight: bold;\n    font-size: 11px;\n    color: var(--black-color);\n}\n\n.stockVariation {\n    font-size: 10px;\n    font-weight: 600;\n    margin-top: 2px;\n}\n\n\n\n.positive {\n    color: var(--_16c098-color);\n}\n\n.negative {\n    color: #d74b4b;\n}\n\n.newsFilters {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.filterButton {\n    border: 1px solid var(--ececf1-border);\n    background: var(--white-background);\n    border-radius: 20px;\n    padding: 4px 12px;\n    font-size: 13px;\n    cursor: pointer;\n}\n\n.coverageButton {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: #16c09824;\n    border: none;\n    color: var(--_16c098-color);\n    font-weight: 600;\n    font-size: 13px;\n    padding: 4px 12px;\n    border-radius: 20px;\n    cursor: pointer;\n    svg{\n        fill: var(--_16c098-color);\n        color: var(--_16c098-color);\n    }\n}\n\n.searchButton {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: var(--f4-background);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    cursor: pointer;\n    margin-left: auto;\n}\n\n.searchButton svg {\n    width: 16px;\n    height: 16px;\n}\n\n\n\n\n\n.bannerOverlay {\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));\n    z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popUpNewsContainer": `popUpNewsContainer_DYpbP`,
	"popUpNewsContainerHeader": `popUpNewsContainerHeader_M71Ph`,
	"popUpNewsContainerItems": `popUpNewsContainerItems_a7odI`,
	"popUpNewsContainerItem": `popUpNewsContainerItem_goTtO`,
	"content": `content_fy48q`,
	"header": `header_Bm1dI`,
	"image": `image_U1oVZ`,
	"sourceEllipsis": `sourceEllipsis_eljo0`,
	"titleEllipsis": `titleEllipsis_aAJSS`,
	"newsImage": `newsImage_PhBu2`,
	"iconOverlay": `iconOverlay_OGhWL`,
	"popUpNewsHeaderBanner": `popUpNewsHeaderBanner_dsx5o`,
	"headerText": `headerText_k1KSM`,
	"magicIconOverlay": `magicIconOverlay_iQRAC`,
	"popUpNewsActionsBar": `popUpNewsActionsBar_tr5Ae`,
	"stockTicker": `stockTicker_OkMPa`,
	"stockItem": `stockItem_qot0P`,
	"stockLeft": `stockLeft_QBWut`,
	"stockType": `stockType_PNia_`,
	"stockName": `stockName_xvxlf`,
	"stockRight": `stockRight_lppsz`,
	"stockPrice": `stockPrice_xkFMb`,
	"stockVariation": `stockVariation_sNVPz`,
	"positive": `positive_h2d90`,
	"negative": `negative_jXYoy`,
	"newsFilters": `newsFilters_QhcIG`,
	"filterButton": `filterButton_yWheq`,
	"coverageButton": `coverageButton_kd1pX`,
	"searchButton": `searchButton_c_EoU`,
	"bannerOverlay": `bannerOverlay_oImKv`
};
export default ___CSS_LOADER_EXPORT___;
